/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosInstance } from "axios";
import { instanceAuthAPI, instanceLoggedAPI } from "../axiosConfig";
import { User, Recover, SetPassword } from "./types";
export default class UserAPIService {
  private axiosInstance: AxiosInstance;
  private axiosLogInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = instanceAuthAPI;
    this.axiosLogInstance = instanceLoggedAPI;
  }

  async registerUser(user: Partial<User>): Promise<unknown> {
    return this.axiosInstance.post("/users", user);
  }
  async getUserRegister(token: string): Promise<unknown> {
    return this.axiosLogInstance.get(`/user/${token}`);
  }
  async updateSignUp(token: any, payload: any): Promise<unknown> {
    return this.axiosInstance.put(`/account_confirmation/${token}`, payload);
  }
  async recoverPassword(user: Partial<Recover>): Promise<unknown> {
    return this.axiosInstance.post("/recover_password", user);
  }
  async resetPassword(data: Partial<SetPassword>): Promise<unknown> {
    return this.axiosInstance.put("/set_password", data);
  }
  async getProfile(): Promise<unknown> {
    return this.axiosLogInstance.get("/profiles");
  }
  async updateUser(data: any, id: number | string): Promise<unknown> {
    return this.axiosLogInstance.put(`/users/${id}`, data);
  }
  async getUsers(): Promise<unknown> {
    return this.axiosLogInstance.get("/users");
  }
  async updateToken(id: any): Promise<unknown> {
    return this.axiosInstance.put(`/account_confirmation/${id}`);
  }
}

export const userAPI = new UserAPIService();
